export default {
  signUpSuccess: 'You\'ve been signed in as well.',
  signUpFailure: 'Email may be taken, or passwords don\'t match.',
  signInSuccess: 'Succesfully signed in.',
  signInFailure: 'Check your email and password and try again.',
  signOutSuccess: 'Come back soon!',
  changePasswordSuccess: 'Password changed.',
  changePasswordFailure: 'Check your old password and try again.'
}



// WEBPACK FOOTER //
// ./src/auth/messages.js